import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex p-4" }
const _hoisted_2 = { class: "pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_TheLogo = _resolveComponent("TheLogo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_ConfirmDialog),
      _createVNode(_component_ConfirmDialog, { group: "demo" }, {
        message: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("i", {
              class: _normalizeClass(slotProps.message.icon),
              style: {"font-size":"1.5rem"}
            }, null, 2),
            _createElementVNode("p", _hoisted_2, _toDisplayString(slotProps.message.message), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Toast, { position: "top-left" }),
      (_ctx.$route.meta.layout !== 'blank')
        ? (_openBlock(), _createBlock(_component_TheLogo, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    }))
  ], 64))
}